export class Messages {
  public static readonly SUCCESS = {
    preferencesSaved: 'Preferences saved successfully!',
    changePassword: 'Your password has been changed successfully.',
    fileDeletemessage: 'File moved to trash!',
    fileDeletePermanentlymessage: 'File deleted permanently!',
    sucessMsgBugCapture: 'We have taken a note.',
    successFileSaved: 'File saved successfully!',
    googleDriveFileSaved: 'Google Drive file saved successfully!',
    googleDriveFileSync: 'Google Drive file sync started!',
    googleIntegration:
      'Google integration successful! Google "open with" tab will show KiwiWrite as an option. Please reload Google tab if not seen.',
    siteAdminCreated: 'New Site Admin has been created successfully',
  };

  public static readonly ERROR = {
    notFound: 'Results Not Found.',
    sessionExpired: 'Your session has been expired.',
    unselectOption: 'Oops! Unselect ABC first.',
    failFileSaved: 'Unable to save file - Something Went Wrong',
    googleDriveFilePageWarning: 'Only 20 pdf pages allowed',
    googleDriveFileNotSaved: 'Google drive file not saved successfully!',
    googleDriveFileRename: 'This file is a view-only Google Classroom file and cannot be renamed.',
    notGoogleUser:
      'Google integration unsuccessful.  You must have and choose a Google account that matches your Kiwi account email to integrate with Google',
    pickedWrongUser:
      "Google integration failed. Please log into the Google account that matches your Kiwi account email. If you're already logged in, ensure you select the correct Google account",
    googlePickerAccessTokenError: 'Kiwi does not have permission to access your Google files. Please enable Google integration in Preferences',
    accountExpired: 'Sorry, your account is expired',
    cvPenShapeDrag: 'Press and drag to draw a shape',
    cvPenFreehandDrag: 'Press and drag to draw freehand',
    cvPenLineDrag: 'Press and drag to draw a single line',
    cvPenMultiLineClick:
      'Click at each turning point to draw a multi-part line or freestyle shape.  Double-click or press and hold for 1 second to end line',
    cvPenNoKeyboardEntry: 'Click the pencil icon to return to the math keys layout to enter math or text',
    cvNoUndoData: 'No data to undo.  Undo cannot be used on work opened from prior saved file',
    cvNoUndoPen: 'No drawings to undo.  To return to math keys click the pencil icon',
  };

  public static readonly validationMessage = {
    userName: 'We need your username.',
    userNameSpaceNotAllowed: 'Your username needs at least one letter and no spaces.',
    userNamePatternInvalid: 'Your username needs at least one letter and no spaces.',
    emailRequired: 'We need your email.',
    emailInvalid: 'Oops! Please enter the right email.',
    password: 'We need your password.',
    passwordLength: 'Password needs 6 or more characters.',
    currentPassword: 'Please enter your current password.',
    currentPasswordLength: 'Current password needs 6 or more characters.',
    newPassword: 'Enter a new password.',
    newPasswordLength: 'Your new password needs 6 or more characters.',
    passwordNotContainSpace: 'Password cannot contain space.',
    verifyPassword: 'Please verify your password.',
    confirmPassword: 'Please confirm your password.',
    passwordNotMatch: 'Oops! Passwords do not match. Try again!',
    termsAndConditionRequired: 'Agree with our terms and conditions?',
    nameEmailNotSpace: 'Oops! Make sure there is no space.',
    name: 'Hi! Tell us your name.',
    namePatternInvalid: 'Oops! Please use only letters and numbers in this field.',
    messagePatternInvalid: "Oops! Please use only letters, numbers, or any of the characters, ?,.'@ in this field.",
    inValidField: 'Please enter a value in each box.',
    nameStartSpaceNotAllowed: 'Oops! Make sure there is no space at the start.',
    messageRequired: 'Please write a message!',
    messageNotContainOnlySpace: 'Oops! Please write a message.',
    selectAtLeastone: 'Please choose a folder!',
    fileRequiredError: 'Please choose a file.',
    pdfPageNumebrs: 'Only 20 pdf pages allowed.',
    fileTypeError: 'Only choose images (PNG/JPEG) or PDFs please!',
    fileNameRequired: 'Please create a file name!',
    emailOrNumber: 'We need your email or text number.',
    emailOrNumberPattern: 'Enter the right email or 10 digit text number.',
    descriptionRequired: 'Please write a description!',
    descriptionNotContainOnlySpace: 'Oops! Please write a description.',
    dateIsRequired: 'Please choose a extended date.',
    contactFirstName: 'We need your first name.',
    contactLastName: 'We need your last name.',
    contactFirstNamePatternInvalid: 'Your first name needs at least one letter and no spaces.',
    contactLastNamePatternInvalid: 'Your last name needs at least one letter and no spaces.',
    schoolName: 'We need your school or district name.',
    nickname: 'We need your nickname.',
    nicknamePatternInvalid: 'Your nickname needs at least one letter and no spaces.',
    schoolEmailDomain: 'We need your school email domain.',
    schoolStaffEmailDomain: 'We need your school staff email domain',
    schoolEmailDomainPatternInvalid:
      'Please enter only the domain name located after the @ sign, without any space or @ characters, ie, csd100.org or stu.csd100.org',
    schoolSubscriptionEndDate: 'We need your school subscription end date.',
    licenseBought: 'We need number of license bought.',
    licenseBoughtPatternInvalid: 'License bought must be a positive number.',
    licenseStartDate: 'We need license start date.',
    licenseEndDate: 'We need license end date.',
    licenseCode: 'We need licenseCode.',
    InvalidFile: 'Invalid file format.',
    FillRemainingFields: ' Please fill out remaining fields.',
    userType: ' Please select your role.',
    subjectRequired: 'Please write subject for email',
    emailMessagePatternInvalid: "Oops! Please use only letters, numbers, or any of the characters, ?,.'@+-= in this field.",
    subjectNotContainOnlySpace: 'Oops! Please write a subject.',
    positiveNumber: 'We need number of',
    inValidNumberInput: 'must be a positive number.',
    emailLength: 'Email length must be less than or equal to 74',
  };

  public static readonly userMessages = {
    searchResultNotFound: 'No users found for this search',
    noUsers: "There aren't any users here yet.",
    noSiteAdminAccess: 'No data found. Please search to filter records.',
  };
  public static readonly domainApprovalMessages = {
    searchResultNotFound: 'No approval request found for this search',
    noUsers: "There aren't any domain request here yet.",
    noSiteAdminAccess: 'No data found. Please search to filter records.',
  };
}
